import api from '@/services/api';

/**
 * Generic file upload service based on the Excel upload logic from InputList
 */

/**
 * Upload a file with optional additional data
 * 
 * @param {string} endpoint - API endpoint for upload
 * @param {File} file - File to upload
 * @param {Object} additionalData - Optional data to send with file (will be JSON stringified)
 * @returns {Promise} Upload promise
 */
export const uploadFile = (endpoint, file, additionalData = {}) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("data", JSON.stringify(additionalData));

    return api.post(endpoint, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

/**
 * Trigger file input dialog
 * 
 * @param {Event} e - The click event
 * @param {React.RefObject} fileInputRef - Ref to file input element
 */
export const triggerFileUpload = (e, fileInputRef) => {
    e.preventDefault();
    fileInputRef.current.click();
};

/**
 * Clear file input value
 * 
 * @param {React.RefObject} fileInputRef - Ref to file input element
 */
export const clearFileInput = (fileInputRef) => {
    if (fileInputRef.current) {
        fileInputRef.current.value = null;
    }
};

export default {
    uploadFile,
    triggerFileUpload,
    clearFileInput
}; 